import { Breadcrumbs, Link, Typography } from "@mui/material";
import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import "../../../Assets/css/mjstatic.css";
// import "../../../Assets/css/cbr_prrivacypulicy.css"
import '../../../Assets/css/cbrPrivacypolicy.css'
import { useSelector } from "react-redux";
import {
  Address_details,
  Email_details,
  client_name,
} from "../../../Helpers/request";

const PrivacyPolicy = () => {
  const Email_details_link = Email_details.link;
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="cbr_privy rcs_ringsetting_section mt-3">
        <Container>
          <Row>
            <Col className="rcs_breadcrumb m-0 mb-md-2">
              <Breadcrumbs aria-label="breadcrumb">
                <NavLink underline="hover" color="inherit" to="/">
                  Home
                </NavLink>
                <Typography color="text.primary">Privacy Policy</Typography>
              </Breadcrumbs>
            </Col>
          </Row>
          <Row className="cbr_row_privacy_policy">
            <Col sm={12}>
              <div className="cbr_privacy_policy cbr_privacy_policy_content">
                <div className="cbr_priv_pvc">
                  <h1 className="cbr_privicy_titel">PRIVACY POLICY</h1>
                  <p>
                    We at {client_name.c_name} are committed to protecting your
                    privacy. We have prepared this Privacy Policy to describe to
                    you our practices regarding the personal data we collect
                    from users of our website.
                  </p>
                  <p>
                    By using the Services, users consent to the collection and
                    use of their Personal Data by us. You also represent to us
                    that you have any and all authorizations necessary to use
                    these Services including using them to process Personal
                    Data. We collect and use the information you provide to us,
                    including information obtained from your use of the
                    Services. Also, we may use the information that we collect
                    for our internal purposes to develop, tune, enhance, and
                    improve our Services, and for advertising and marketing
                    consistent with this Privacy Policy.
                  </p>
                  <p>
                    This privacy policy has been compiled to better serve those
                    who are concerned with how their ‘Personal Data’ is being
                    used online. Personal Information means data which relate to
                    a living individual who can be identified – (a) from those
                    data, or (b) from those data and other information which is
                    in the possession of, or is likely to come into the
                    possession of, the data controller, and includes any
                    expression of opinion about the individual and any
                    indication of the intentions of the data controller or any
                    other person in respect of the individual.
                  </p>
                  <p>
                    Please read our privacy policy carefully to get a clear
                    understanding of how our website collects, uses, protects or
                    otherwise handles users’ Personal Data.
                  </p>
                  <p>
                    This Privacy Policy is intended to inform users about how
                    our website treats Personal Data that it processes about
                    users. If users do not agree to any part of this Privacy
                    Policy, then we cannot provide its Services to users and
                    users should stop accessing our services.
                  </p>
                  <p>
                    By using the Services, You acknowledge, consent and agree
                    that we may collect, process, and use the information that
                    you provide to us and that such information shall only be
                    used by us or third parties acting under our direction,
                    pursuant to confidentiality agreements, to develop, tune,
                    enhance, and improve the Services. Although we may attempt
                    to notify you when changes are made to this Privacy Policy,
                    you are responsible for periodically reviewing any changes
                    which may be made to the Policy. We may, in our sole
                    discretion, modify or revise the Policy at any time, and you
                    agree to be bound by the same.
                  </p>
                  <p>
                    Our privacy policy is subject to change at any time without
                    notice. To make sure you are aware of any changes, please
                    review this policy periodically.
                  </p>
                </div>
                {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                <div className="cbr_privacy_information">
                  <h4>INFORMATION WE COLLECT:</h4>
                  <ol>
                    <li>
                      <p>
                        You provide us information about yourself – Your Full
                        Name, Card Information, Address, email address. If you
                        correspond with us by e-mail, we may retain the content
                        of your e-mail messages, your e-mail address, and our
                        responses. Additionally, we store information about
                        users’ contacts when users manually enter contact e-mail
                        addresses or transfer contact information from other
                        online social networks. We also collect general
                        information about your use of our services.
                      </p>
                    </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>
                    INFORMATION WE COLLECT AUTOMATICALLY WHEN YOU USE OUR
                    SERVICES:
                  </h4>
                  <ol>
                    <li>
                      <p>
                        When you access or use our Services, we automatically
                        collect information about you, including:
                      </p>
                    </li>
                    <li>
                      {" "}
                      <p>
                        Usage Information: If you choose to post messages on our
                        message boards, online/ offline chats or other message
                        areas or leave feedback for other users, we retain this
                        information as necessary to resolve disputes, provide
                        customer support and troubleshoot problems as permitted
                        by law. If you send us personal correspondence, such as
                        emails or letters, or if other users or third parties
                        send us correspondence about your activities on the
                        Website, we may collect such information into a file
                        specific to you.
                      </p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>
                        Log Information: We log information about your use of
                        our Website, including your browser type and language,
                        access times, pages viewed, your IP address and the
                        Website you viewed before navigating to our Website.
                      </p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>
                        Device Information: We may collect information about the
                        device you use to access our Services, including the
                        hardware model, operating system and version, unique
                        device identifier, phone number, International Mobile
                        Equipment Identity (“IMEI”) and mobile network
                        information.
                      </p>
                    </li>
                    <li>
                      {" "}
                      <p>
                        Location Information: With your consent, we may collect
                        information about the location of your device to
                        facilitate your use of certain features of our Services,
                        determine the speed at which your device is traveling,
                        add location-based filters (such as local weather), and
                        for any other purposes.
                      </p>{" "}
                    </li>
                    <li>
                      <p>
                        Information Collected by Cookies and Other Tracking
                        Technologies: We use various technologies to collect
                        information, and this may include sending cookies to
                        you. A “cookie” is a small data file transferred to your
                        computer’s hard drive that allows a Website to respond
                        to you as an individual, gathering and remembering
                        information about your preferences in order to tailor
                        its operation to your needs, likes and dislikes.
                        Overall, cookies are safe, as they only identify your
                        computer to customize your Web experience. Accepting a
                        cookie does not provide us access to your computer or
                        any Personally Identifiable Information about you, other
                        than the information you choose to share. Other servers
                        cannot read them, nor can they be used to deliver a
                        virus. Most browsers automatically accept cookies, but
                        you can usually adjust yours (Microsoft Internet
                        Explorer, Firefox or Google Chrome) to notify you of
                        cookie placement requests, refuse certain cookies, or
                        decline cookies completely. If you turn off cookies
                        completely, there may be some Website features that will
                        not be available to you, and some Web pages may not
                        display properly. To support the personalized features
                        of our Website (such as your country and language codes
                        and browsing functions) we must send a cookie to your
                        computer’s hard drive and/or use cookie-based
                        authentication to identify you as a registered Website
                        user. We do not, however, use so-called “surveillance”
                        cookies that track your activity elsewhere on the Web.
                        We may also collect information using web beacons (also
                        known as “tracking pixels”).
                      </p>{" "}
                    </li>
                    <li>
                      <p>
                        “Web beacons” or clear .gifs are small pieces of code
                        placed on a Web page to monitor behavior and collect
                        data about the visitors viewing a Web page. For example,
                        Web beacons or similar technology can be used to count
                        the users who visit a Website or to deliver a cookie to
                        the browser of a visitor viewing that page. We may use
                        Web beacons or similar technology on our Services from
                        time to time for this and other purposes.
                      </p>{" "}
                    </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>HOW WE USE YOUR INFORMATION:</h4>
                  <ol>
                    <li>
                      <p>
                        We use the personal information we collect to fulfill
                        your requests for services, improve our services,
                        contact you, conduct research, and provide anonymous
                        reporting for internal and external clients.
                      </p>{" "}
                    </li>
                    <li>
                      <p>
                        By providing us your e-mail address, you consent to us
                        using the e-mail address to send you our Website and
                        services related notices, including any notices required
                        by law, in lieu of communication by postal mail. You
                        also agree that we may send notifications of activity on
                        our Website to the e-mail address you give us, in
                        accordance with any applicable privacy settings. We may
                        use your e-mail address to send you other messages, such
                        as newsletters, changes to our features, new services,
                        events or other information. If you do not want to
                        receive optional e-mail messages, you may modify your
                        settings to opt out.
                      </p>
                    </li>
                    <li>
                      <p>
                        Our settings may also allow you to adjust your
                        communications preferences. If you do not wish to
                        receive promotional email messages from us, you may opt
                        out by following the unsubscribe instructions in those
                        emails. If you opt out, you will still receive
                        non-promotional emails from us about our Services.
                      </p>
                    </li>
                    <li>
                      <p>
                        Following termination or deactivation of your services,
                        we may (but are under no obligation to) retain your
                        information for archival purposes. We will not publicly
                        disclose any of your personally identifiable information
                        other than as described in this Privacy Policy.
                      </p>
                    </li>
                    <li>
                      <p>
                        Following termination or deactivation of your services,
                        we shall be under an obligation to delete all your
                        personal information if you notify the same to us
                        through email with subject as “Personal Information
                        Removal” at <a href="mailto:customerservice@colturedbrilliance.com"> customerservice@colturedbrilliance.com</a>
                        
                      </p>
                    </li>
                    <li>
                      <p>Removing any content or messages:</p>
                      <ul>
                        <li>
                          <p className="cbr_iner_p">
                            {/* <span>6.1</span> */}
                            At our sole discretion, for any reason or no reason
                            at all, we reserve the right to remove any content
                            or messages, if we believe that such action is
                            necessary:
                          </p>
                        </li>
                        <li>
                          <p>
                            To conform to the law, comply with legal process
                            served on us or our affiliates, or investigate,
                            prevent, or take action regarding suspected or
                            actual illegal activities;
                          </p>{" "}
                        </li>
                        <li>
                          <p>
                            To enforce this policy, to take precautions against
                            liability, to investigate and defend ourselves
                            against any third-party claims or allegations, to
                            assist government enforcement agencies, or to
                            protect the security or integrity of our Website; or
                            (c) to exercise or protect the rights, property, or
                            personal safety of the Website, our users, or
                            others.
                          </p>{" "}
                        </li>
                      </ul>
                    </li>
                    <li>
                      <p>Business Providers; Unaffiliated Businesses:</p>
                      <ul>
                        <li>
                          <p className="cbr_iner_p">
                            At times, we may provide products, services or
                            offerings through our Services in cooperation with
                            an unaffiliated third party. We may share personally
                            identifiable information that you provide in
                            connection with any such products, services or
                            offerings with the unaffiliated third party(ies)
                            involved in your particular product, service or
                            offering. For instance, when you express interest in
                            products, services, promotions, that we offer (for
                            example, by completing a request for or information
                            regarding such services or completing an entry form
                            for a promotion), we will share your request or
                            expression of interest with the businesses with
                            which we partner to offer you those products,
                            services, promotions, and, as applicable, with their
                            affiliates and third party finder or marketing
                            companies (collectively, “Business Providers”). By
                            electing to participate or otherwise expressing
                            interest in any such product, service or offering
                            conducted in conjunction with any Business Provider,
                            you expressly authorize us to provide your
                            personally identifiable information to those
                            Business Providers. Please be aware the Business
                            Providers with whom we share your personally
                            identifiable information may retain or use your
                            information whether or not you use their services,
                            and the privacy and information sharing practices of
                            such Business Providers may differ from those
                            described in this Privacy Policy. Additionally, we
                            may share personally identifiable information with
                            unaffiliated third parties to whom you explicitly
                            ask us to send your information. If you prefer not
                            to be contacted by any such Business Provider or
                            other third party with whom we share your personally
                            identifiable information, you may follow the
                            “unsubscribe” instructions provided in any email you
                            receive from any such third party. In addition, you
                            may opt-out of our sharing your personally
                            identifiable information with Business Providers and
                            other third parties by following the instructions on
                            our Email Opt Out Form, as described below under
                            “Your Options Regarding Personally Identifiable
                            Information”.
                          </p>
                        </li>
                      </ul>
                    </li>

                    <li>
                      <p>Third Party Service Providers:</p>
                      <ul>
                        <li>
                          <p className="cbr_iner_p">
                            We employ other companies and individuals to perform
                            functions on our behalf. Examples may include
                            providing marketing assistance, providing search
                            results and links (including paid listings and
                            links), processing credit card payments and
                            providing customer service. In connection with their
                            performance of functions on our behalf, we may share
                            personally identifiable information with such
                            companies and individuals as needed for them to
                            perform their functions, but we do not permit such
                            entities and individuals to use personally
                            identifiable information for other purposes. In
                            addition, we may provide non-personally-identifiable
                            information to advertisers and other third parties
                            for their use in marketing efforts for us,
                            themselves, or others. If you are not interested in
                            receiving targeted advertisements or other marketing
                            information or materials as a result of such
                            efforts, you may adjust the settings on your mobile
                            devices to prevent the use of your
                            non-personally-identifiable information in this
                            manner.
                          </p>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <p>Third Party Promotions:</p>
                      <ul>
                        <li>
                          <p className="cbr_iner_p">
                            We may send offers to selected groups of customers
                            on behalf of unaffiliated businesses that want to
                            market their products or services to you, and as
                            part of these promotional offers we may sell or
                            disclose certain of your personally identifiable
                            information to such unaffiliated businesses. If you
                            prefer not to be contacted by any such business with
                            whom we share your personally identifiable
                            information, you may follow the “unsubscribe”
                            instructions provided in any email you receive from
                            any such third party. In addition, you may opt-out
                            of our sharing your personally identifiable
                            information with such businesses by following the
                            instructions on our Email Opt Out Form, as described
                            below under “Your Options Regarding Personally
                            Identifiable Information”.
                          </p>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <p>In-House Promotions:</p>
                      <ul>
                        <li>
                          <p className="cbr_iner_p">
                            We may on occasion combine information we receive
                            through our Services with outside records to enhance
                            our ability to market our products and services that
                            may be of interest to you. If you have signed up to
                            receive our e-mails and prefer not to receive
                            marketing information in connection with our
                            Services, please follow the “unsubscribe”
                            instructions provided on any marketing e-mail you
                            receive in connection with our Services or by
                            following the instructions in our Email Opt Out
                            Form, as described below under “Unsubscribe
                            Requests”.
                          </p>
                        </li>
                      </ul>
                    </li>

                    <li>
                      <p>Business Transfers:</p>
                      <ul>
                        <li>
                          <p className="cbr_iner_p">
                            As our businesses continue to evolve, we might sell
                            one or more of our companies, subsidiaries or
                            business units. In such transactions, personally
                            identifiable information generally is one of the
                            transferred business assets. In such event, this
                            Privacy Policy may be amended as set forth below or
                            the collection and uses of your personally
                            identifiable information may be governed by a
                            different privacy policy.
                          </p>
                        </li>
                      </ul>
                    </li>
                    <li>
                        <p> 
                        Protection of Our Services and Others:
                        </p>
                        <ul>
                        <li>
                        <p className="cbr_iner_p">
                      We reserve the right to release personally identifiable
                      information to unaffiliated third parties when we believe
                      its release is appropriate to comply with the law, enforce
                      or apply our Terms and Conditions and other agreements, or
                      protect the rights, property or safety of
                      {client_name.c_name}, our users or others. This includes
                      exchanging information with other unaffiliated third
                      parties in connection with fraud protection and credit
                      risk reduction.
                    </p>
                        </li>
                        </ul>
                    </li>
                   <li>
                   <p> With Your Consent:</p>
                   <ul>
                    <li>
                    <p className="cbr_iner_p">
                      Other than as set out above, you will receive notice and
                      have the opportunity to withhold consent when personally
                      identifiable information about you might be shared with
                      unaffiliated third parties.
                    </p>
                    </li>
                   </ul>
                   </li>
                
                    <li> 
                    <p>
                      User Data
                    </p>
                   <ul>
                    <li>
                    <p className="cbr_iner_p">
                      We may transmit the user data across the various Websites
                      of the Company.
                    </p>
                    </li>
                   </ul>
                    </li>
                    <li>
                    <p>
                      User Submissions:
                    </p>
                     <ul>
                    <li>
                    <p className="cbr_iner_p">
                      If you participate in any online forum/communities, chat
                      sessions and/or blogs, or otherwise post in any user
                      comment field visible to other users of our Services, any
                      information that you submit or post will be visible to and
                      may be read, collected or used by others who use our
                      Services. We are not responsible for any information,
                      including personally identifiable information, you choose
                      to submit in any such user comment field.
                    </p>
                    </li>
                     </ul>
                    </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>HOW WE SHARE YOUR INFORMATION:</h4>
                  <ol>
                    <li>
                      <p>
                        As a matter of policy, we will not sell or rent
                        information about you and we will not disclose
                        information about you in a manner inconsistent with this
                        Privacy Policy except as required by law or government
                        regulation. We cooperate with law enforcement inquiries,
                        as well as other third parties, to enforce laws such as
                        those regarding intellectual property rights, fraud and
                        other personal rights.
                      </p>
                    </li>
                    <li>
                      <p>
                        We will not share the personal information we collect
                        about you with any third party for their own marketing
                        purposes without your consent. We may share your data
                        with our services providers who process your personal
                        information to provide services to us or on our behalf.
                        We have contracts with our service providers that
                        prohibit them from sharing the information about you
                        that they collect or that we provide to them with anyone
                        else, or using it for other purposes.
                      </p>
                    </li>
                    <li>
                      <p>
                      You may decline to submit Personally Identifiable
                      Information through the Services, in which case we may not
                      be able to provide certain services to you. If you do not
                      agree with our Privacy Policy or Terms of Service, please
                      discontinue use of our Service; your continued usage of
                      the Service will signify your assent to and acceptance of
                      our Privacy Policy and Terms of Use.
                    </p>
                    </li>
                    <li>
                      <p>
                      WE CAN (AND YOU AUTHORIZE US TO) DISCLOSE ANY INFORMATION
                      ABOUT YOU TO LAW ENFORCEMENT, OTHER GOVERNMENT OFFICIALS,
                      ANY LAWSUIT OR ANY OTHER THIRD PARTY THAT WE, IN OUR SOLE
                      DISCRETION, BELIEVE NECESSARY OR WEBSITE APPROPRIATE IN
                      CONNECTION WITH AN INVESTIGATION OF FRAUD, INTELLECTUAL
                      PROPERTY INFRINGEMENT, OR OTHER ACTIVITY THAT IS ILLEGAL
                      OR MAY EXPOSE US, OR YOU, TO LIABILITY.
                    </p>
                    </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>ENSURING INFORMATION IS ACCURATE AND UP-TO-DATE</h4>
                  <ol>
                    <li> 
                    <p>
                    We take reasonable precautions to ensure that the Personal
                    Information we Collect, Use and Disclose is complete,
                    relevant and up-to-date. However, the accuracy of that
                    information depends to a large extent on the information you
                    provide. That’s why we recommend that you:
                  </p>
                  </li>
                  <li> 
                    <p>
                    Let us know if there are any errors in your Personal
                    Information; and
                  </p>
                  </li>
                  <li>
                    <p>
                    Keep us up-to-date with changes to your Personal Information
                    such as your name or address.
                    </p>
                  </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>HOW WE PROTECT YOUR INFORMATION:</h4>
                  <ol>
                    <li> 
                    <p>
                    We are very concerned about safeguarding the confidentiality
                    of your personally identifiable information. We employ
                    administrative, physical and electronic measures designed to
                    protect your information from unauthorized access.
                  </p>
                  </li>
                  <li> 
                    <p>
                    By using this Website or the Services or providing Personal
                    Information to us, you agree that we can communicate with
                    you electronically regarding security, privacy, and
                    administrative issues relating to your use of this Website
                    or Services.
                  </p>
                  </li>
                  <li> 
                    <p>
                    We use commercially reasonable physical, managerial, and
                    technical safeguards to preserve the integrity and security
                    of your Personal Information. Your sensitive information,
                    such as credit card information, debit card information is
                    encrypted when it is transmitted to us. Our employees are
                    trained and required to safeguard your information. We
                    cannot, however, ensure or warrant the security of any
                    information you transmit to us and you do so at your own
                    risk. Using unsecured wi-fi or other unprotected networks to
                    submit messages through the Service is never recommended.
                    Once we receive your transmission of information, we make
                    commercially reasonable efforts to ensure the security of
                    our systems. However, please note that this is not a
                    guarantee that such information may not be accessed,
                    disclosed, altered, or destroyed by breach of any of our
                    physical, technical, or managerial safeguards. If we learn
                    of a security systems breach, then we may attempt to notify
                    you electronically so that you can take appropriate
                    protective steps
                  </p>
                  </li>
                  <li> 
                    <p>
                    Notwithstanding anything to the contrary in this Policy, we
                    may preserve or disclose your information if we believe that
                    it is reasonably necessary to comply with a law, regulation
                    or legal request; to protect the safety of any person; to
                    address fraud, security or technical issues; or to protect
                    our rights or property. However, nothing in this Policy is
                    intended to limit any legal defenses or objections that you
                    may have to a third party, including a government’s request
                    to disclose your information.
                  </p>
                  </li>
                  <li> 
                    <p>
                    However, no data transmission over the Internet or data
                    storage system can be guaranteed to be 100% secure. Please
                    do not send us credit card information and/or other
                    sensitive information through email. If you have reason to
                    believe that your interaction with us is not secure (for
                    example, if you feel that the security of any account you
                    might have with us has been compromised), you must
                    immediately notify us of the problem by contacting us in
                    accordance with the “Contact Us” section available on our
                    Website.
                  </p>
                  </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>SPECIAL CATEGORIES OF PERSONAL DATA</h4>
                  <ol>
                    <li> 
                    <p>
                    Some of the data that you provide us will fall within what
                    EU data protection law describes as ‘special categories of
                    personal data’, such as your racial or ethnic origin,
                    religious beliefs or information concerning your health or
                    sexual orientation.
                  </p>
                  </li>
                  <li> 
                    <p>
                    We use this information in the same way we use all the other
                    information we collect, but the law requires that we have
                    your explicit consent to collect and use it.
                  </p>
                  </li>
                  <li> 
                    <p>
                    By accepting our updated Privacy Policy, you consent to{" "}
                    {client_name.c_name} to using this information.
                  </p>
                  </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>LEGAL GROUNDS FOR PROCESSING YOUR PERSONAL DATA</h4>
                  <ol>
                    <li>
                    <p>
                     {client_name.c_name}  is committed to the lawful, fair and
                    transparent use of personal data. For every use of your
                    personal data we have described so far, we process your
                    personal data on the grounds that our processing is
                    necessary for legitimate interests we pursue as a business,
                    namely that our business relies entirely on the ability to
                    use your personal data to produce research and insight for
                    our clients.
                  </p>
                    </li>
                    <li>
                    <p>
                    If you have any questions about the grounds under which we
                    process your personal data, or would like to find out more
                    about the approach we take to determine that these grounds
                    apply, please contact our Data Protection Officer at  
                     <a href="mailto:customerservice@colturedbrilliance.com">  customerservice@colturedbrilliance.com     
                    </a>
                  </p>
                    </li>
                  </ol>
                 
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>TRANSFERRING PERSONAL DATA OUTSIDE THE EEA</h4>
                  <p className="cbr_transfering">
                    At this time,{client_name.c_name} only conducts business in
                    the continental United States of America plus Alaska and
                    Hawaii. YOUR CALIFORNIA PRIVACY RIGHTS
                  </p>
                  <ol>
                    <li> 
                  <p>
                    If you are a customer in California, in addition to the
                    rights set forth above, you have the right to request
                    information from Brilliant Earth regarding the manner in
                    which Brilliant Earth shares certain categories of personal
                    information as defined by California’s “Shine the Light”
                    with third parties and/or affiliates for their own direct
                    marketing purposes. To receive this information, send us a
                    request at the address set forth in the section entitled
                    “Contact Us” below. Requests must include “California
                    Privacy Rights Request” in the first line of the description
                    and include your name, street address, city, state, and ZIP
                    code. Please note that Brilliant Earth may provide this
                    information in a standardized format that is not specific to
                    you and is not required to respond to requests made by means
                    other than through the provided e-mail address or mail
                    address.
                  </p>
                  </li>
                  <li> 
                  <p>
                    Any California residents under the age of eighteen (18) who
                    have registered to use the Service and posted content or
                    information on the Service, can request that such
                    information be removed from the Service by sending an e-mail
                    to the e-mail address set forth in the section entitled
                    “Contact Us” below. Requests must state that the user
                    personally posted such content or information and detail
                    where the content or information is posted. We will make
                    reasonable good faith efforts to remove the post from
                    prospective public view.
                  </p>
                  </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>YOUR CHOICES ABOUT YOUR INFORMATION:</h4>
                  <ol>
                    <li> 
                  <p>
                    You have several choices regarding use of information on our
                    Services:
                  </p>
                  </li>
                  <li> 
                  <p>
                    Email Communications: We will periodically send you free
                    newsletters and e- mails that directly promote the use of
                    our Website, or Services. When you receive newsletters or
                    promotional communications from us, you may indicate a
                    preference to stop receiving further communications from us
                    and you will have the opportunity to “opt-out” by following
                    the unsubscribe instructions provided in the e-mail you
                    receive or by contacting us directly. Despite your indicated
                    e-mail preferences, we may send you service related
                    communications, including notices of any updates to our
                    Terms of Use or Privacy Policy.
                  </p>
                  </li>
                  <li> 
                  <p>
                    You may, of course, decline to submit personally
                    identifiable information through the Website, in which case,
                    we will not be able to provide our services to you
                  </p>
                  </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>CHILDREN’S PRIVACY:</h4>
                  <div className="cbr_childern">
                    <p>
                      Our services are available only to persons who can form a
                      legally binding contract with us as per the applicable
                      laws. Protecting the privacy of young children is
                      especially important. Thus, we do not knowingly collect or
                      solicit personal information from anyone under the age of
                      18 or knowingly allow such persons to register. If you are
                      under 18, please do not attempt to register for the
                      Service or send any information about yourself to us,
                      including your name, address, telephone number, or email
                      address. No one under the age of 18 may provide any
                      personal information for listing any service.
                    </p>
                  </div>
                  <h4>MERGER AND ACQUISITIONS:</h4>
                  <h3>CONTENTS</h3>
                  <div className="cbr_childern">
                    <p>
                      In case of a merger or acquisition, we reserve the right
                      to transfer all the information, including personally
                      identifiable information, stored with us to the new entity
                      or company thus formed. Any change in the Website’s
                      policies and standing will be notified to you through
                      email.
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>LINKS TO THIRD PARTY WEBSITE:</h4>
                  <div className="cbr_childern">
                    <p>
                      Our website contains links to other websites. The fact
                      that we link to a website is not an endorsement,
                      authorization or representation of our affiliation with
                      that third party. We do not exercise control over third
                      party websites. These other websites may place their own
                      cookies or other files on your computer, collect data or
                      solicit personally identifiable information from you.
                      Other websites follow different rules regarding the use or
                      disclosure of the personally identifiable information you
                      submit to them. We encourage you to read the privacy
                      policies or statements of the other websites you visit.
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>NOTIFICATION PROCEDURES:</h4>
                  <div className="cbr_childern">
                    <p>
                      It is our policy to provide notifications, whether such
                      notifications are required by law or are for marketing or
                      other business related purposes, to you via e-mail notice,
                      written or hard copy notice, or through conspicuous
                      posting of such notice on the Website, as determined by us
                      in our sole discretion. We reserve the right to determine
                      the form and means of providing notifications to you,
                      provided that you may opt out of certain means of
                      notification as described in this Privacy Policy.
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>OPTING OUT OF INFORMATION SHARING:</h4>
                  <ol>
                    <li> 
                  <p>
                    We understand and respect that not all users may want to
                    allow us to share their information with other select users
                    or companies. If you do not want us to share your
                    information, please contact us through the Contact Us page,
                    and we will remove your name from lists we share with other
                    users or companies as soon as reasonably practicable or you
                    can also click on unsubscribe. When contacting us, please
                    clearly state your request, including your name, mailing
                    address, email address and phone number. In case you do not
                    want your name to be displayed on the Website, you may opt
                    for the same by choosing a Username other than your original
                    name when creating an account with us.
                  </p>
                  </li>
                  <li> 
                  <p>
                    However, under the following circumstances, we may still be
                    required to share your personal information:
                  </p>
                  </li>
                  <li> 
                  <p>
                    If we respond to court orders or legal process, or if we
                    need to establish or exercise our legal rights or defend
                    against legal claims.
                  </p>
                  </li>
                  <li> 
                  <p>
                    If we believe it is necessary to share information in order
                    to investigate, prevent or take action regarding illegal
ggactivities, suspected fraud, situations involving potential
                    threats to the physical safety of any person, violations of
                    our Terms of Use or as otherwise required by law.
                  </p>
                  </li>
                  <li> 
                  <p>
                    If we believe it is necessary to restrict or inhibit any
                    user from using any of our Website, including, without
                    limitation, by means of “hacking” or defacing any portion
                    thereof.
                  </p>
                  </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>USER SUBMISSIONS</h4>
                  <div className="cbr_childern">
                    <p>
                      You understand that when using the Platform, you will be
                      exposed to Content from a variety of sources, and that we
                      are not responsible for the accuracy, usefulness, safety,
                      or intellectual property rights of or relating to such
                      Content and you agree and assume all liability for your
                      use. You further understand and acknowledge that you may
                      be exposed to Content that is inaccurate, offensive,
                      indecent, or objectionable, defamatory or libelous and you
                      agree to waive, and hereby do waive, any legal or
                      equitable rights or remedies you have or may have against
                      us with respect thereto. If you find any content to be
                      libelous, objectionable, defamatory, and indecent or
                      infringing your Intellectual Property Rights, you may
                      contact us directly through “Contact Us” page and we shall
                      take appropriate action to remove such content from the
                      Website.
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>PHISHING OR FALSE EMAILS:</h4>
                  <div className="cbr_childern">
                    <p>
                      If you receive an unsolicited email that appears to be
                      from us or one of our members that requests personal
                      information (such as your credit card, login, or
                      password), or that asks you to verify or confirm your
                      account or other personal information by clicking on a
                      link, that email was likely to have been sent by someone
                      trying to unlawfully obtain your information, sometimes
                      referred to as a “phisher” or “spoofer.” We do not ask for
                      this type of information in an email. Do not provide the
                      information or click on the link. Please contact us at 
                      <a href="mailto:customerservice@colturedbrilliance.com"> customerservice@colturedbrilliance.com </a>
                       if you get an email like this.
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>CHANGES TO OUR PRIVACY POLICY:</h4>
                  <div className="cbr_childern">
                    <p>
                      We may update this Privacy Policy and information security
                      procedures from time to time. If these privacy and/or
                      information security procedures materially change at any
                      time in the future, we will post the new changes
                      conspicuously on the Website to notify you and provide you
                      with the ability to opt out in accordance with the
                      provisions set forth above. Continued use of our Website
                      and Service, following notice of such changes shall
                      indicate your acknowledgement of such changes and
                      agreement to be bound by the terms and conditions of such
                      changes.
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>
                    COLLECTION OF INFORMATION BY THIRD-PARTY WEBSITES, SERVICES,
                    AD SERVERS AND SPONSORS
                  </h4>
                  <ol>
                    <li>
                    <p>
                    Our Services may contain links to other Websites or services
                    whose information practices may be different than ours. For
                    example, while using one or more of our Websites, you may
                    link to a third party’s Website via a window opened within
                    (or on top of) our Website. Some of our Services may allow
                    users to interface with third party Websites or services,
                    such as Facebook and Twitter. You will remain logged into
                    those third party Websites or services until you actively
                    log off. By interfacing with those third party Websites or
                    services, you are allowing our Services to access your
                    information that is or becomes available via such third
                    party Websites or services, and you are agreeing to those
                    third party’s applicable terms and conditions. Once you log
                    onto any such third party Websites or services, the content
                    you post there may also post to our Services. Our Privacy
                    Policy and procedures may or may not be consistent with the
                    policies and procedures of such third party Websites or
                    services, and when you visit such Websites or services our
                    Privacy Policy does not apply to personally identifiable
                    information and other data collected by the third party. You
                    should consult, read and understand the privacy notices of
                    such third parties before choosing to provide personally
                    identifiable information on any such Websites or services.
                  </p>
                    </li>
                    <li>
                    <p>
                    Our Services may also use a third party ad server to present
                    the advertisements that you may see on our Services. These
                    third party ad servers may use cookies, Web beacons, clear
                    .gifs or similar technologies to help present such
                    advertisements, and to help measure and research the
                    advertisements’ effectiveness. The use of these technologies
                    by these third party ad servers is subject to their own
                    privacy policies and is not covered by our Privacy Policy.
                  </p>
                    </li>
                  </ol>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>BREACH OF PRIVACY POLICY:</h4>
                  <div className="cbr_childern">
                    <p>
                      We reserve the right to terminate or suspend your usage of
                      this Website immediately if you are found to be in
                      violation of our privacy policy. We sincerely request you
                      to respect privacy and secrecy concerns of others. The
                      jurisdiction of any breach or dispute shall be Cobb
                      County, GA, United States of America.
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>NO RESERVATIONS:</h4>
                  <div className="cbr_childern">
                    <p>
                      We do not accept any reservation or any type of limited
                      acceptance of our privacy policy. You expressly agree to
                      each and every term and condition as stipulated in this
                      policy without any exception whatsoever.
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>NO CONFLICT:</h4>
                  <div className="cbr_childern">
                    <p>
                      The policy constitutes a part of the user terms. We have
                      taken utmost care to avoid any inconsistency or conflict
                      of this policy with any other terms, agreements or
                      guidelines available on our Website. In case there exists
                      a conflict, we request you to kindly contact us for the
                      final provision and interpretation.{" "}
                    </p>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  <h4>CONTACT US:</h4>
                  <div className="cbr_childern">
                    <p>
                      If you have any questions about this Privacy Policy, our
                      practices relating to the website, or your dealings with
                      us, please contact the Privacy Team at:{" "}
                      <a href="mailto:     customerservice@colturedbrilliance.com     ">
                             customerservice@colturedbrilliance.com     
                      </a>
                    </p>
                  </div>
                </div>

                {/* <p>We{client_name.c_name} </p>
                               
                                <h2>Data Controller</h2>
                                <p>EU data protection law makes a distinction between organizations that process personal data for their own purposes (known as “controllers”) and organizations that process personal data on behalf of other organizations (known as “processors”). {client_name.c_name}, located at the address in the section entitled “Contact Us” below, is the controller with respect to information you provide through the Service.</p>
                                <h2>Information We Collect</h2>
                                <h2>Information You Provide</h2>
                                <p>We collect information you provide directly via the Service, including when you register an account, update your profile, access our content, make a purchase, participate in a sweepstakes, contest, survey, or other promotion (“Promotion”), contact customer support, or apply for a job. We may use Service Providers (defined below) to collect this information.</p>
                                <p>The information we collect includes information that identifies you personally (whether alone or in combination). Some examples of information we collect include the following:</p>
                                <p><strong>Contact Data.</strong> We collect your first and last name, e-mail address, postal address, phone number, and other similar contact data.</p>
                                <p><strong>Credentials</strong>We collect passwords and other information for authentication and account access.</p>
                                <p><strong>Demographic Data.</strong>We collect demographic information including your age, gender, and country.</p>
                                <p><strong>Payment Data.</strong>We collect data necessary to process your payment if you make a purchase, including your payment instrument number (such as a credit card number), and the security code associated with your payment instrument.</p>
                                <p><strong>Profile Data.</strong>We collect your interests, favorites, wish lists, ring size preferences, and other profile data.</p>
                                <p><strong>Contacts.</strong>We collect data about your contacts in order to fulfill a request by you. For example, when you e-mail a product to a friend or refer a friend through the Service, we request that you provide names and e-mail addresses for you and your friend. This helps ensure that your friend will know that you have requested that {client_name.c_name} send them an e-mail. The information {client_name.c_name} collects from you and your friend will only be used in ways as set forth in this Privacy Policy. By using this functionality, you acknowledge and agree that you have your contacts’ consent for us to use their contact information to fulfill your request.</p>
                                <p><strong>Content.</strong>We collect the content of messages you send to us, such as feedback and product reviews you write, or questions and information you provide to customer support. For example, if you contact a customer service representative or jewelry consultant and provide information to the consultant or submit a request through our Service, we will use your information to respond to your request and to provide you with additional information that we believe may be helpful to you. We may also collect content such as photos, videos or other content that you submit to us.</p>
                                <p><strong>Resume Data.</strong>We collect data as necessary to consider you for a job opening if you submit an application to us, including your employment history, transcript, writing samples, and references.</p>
                                <p>You may choose to voluntarily submit other information to us through the Service that we do not request, and, in such instances, you are solely responsible for such information.</p>
                                <h2>Information Collected Automatically</h2>
                                <p>{client_name.c_name} automatically collects information about your device and how your device interacts with our Service. We may use Service Providers to collect this information. Some examples of information we collect include the following:</p>
                                <p><strong>Service Use Data.</strong>We collect data about the features you use, the pages you visit, the e-mails and advertisements you view, the products you purchase, the time of day you browse, your referring and exiting pages, and other similar information.</p>
                                <p><strong>Device Connectivity and Configuration Data.</strong>We collect data about the type of device or browser you use, your device’s operating software, your internet service provider, your device’s regional and language settings, and other similar information.</p>
                                <p><strong>IP Address and Device Identifiers.</strong>{client_name.c_name} collects your IP address and other device identifiers, including your MAC address and mobile advertising identifiers. We collect this data for various purposes, including to assess, diagnose problems, and improve functioning of our Service, servers, and hosting providers as well as to analyze trends and traffic patterns, gather demographic information, track the date, time, and duration of each session within our website, prevent fraud, and customize our services and advertisements.</p>
                                <p><strong>Location Data</strong>We collect data about your device’s location, which can be precise (e.g., latitude/longitude data) or imprecise (e.g., location derived from an IP address or data that indicates a city or postal code level).</p>
                                <p>{client_name.c_name} collects data through the use of cookies, web logs, web beacons and other tracking technologies (now and hereafter developed) (“Tracking Technologies”), including the following:</p>
                                <p><strong>Log Files.</strong>Our server logs automatically collect information, such as your IP address, your browser type and language, and the date and time of your visit, which helps us track users' movements around our site and understand trends.</p>
                                <p><strong>Cookies.</strong>“Cookies” are small pieces of information that are stored by your browser on your device's hard drive. We use cookies on certain pages of our Service to, among other things, analyze our web page flow, measure promotional effectiveness, deliver you a more customized shopping experience, track visits from our affiliates and partners and allow the use of our shopping cart.</p>
                                <ul>
                                    <li>{client_name.c_name} uses cookies for various purposes, including the following:</li>
                                    <li>Operational: Cookies are essential in order for you to use our Service, such as our shopping bag, as well as to access password protected areas, such as your personal account.</li>
                                    <li>Analytics and Performance: Cookies collect information about how you use our Service and remember the choices you make (such as your language or location) to provide an enhanced performance and a more personalized experience.</li>
                                    <li>Customization: Cookies allow us to gather information on how our Service is being used so that we can provide content that is relevant to you.</li>
                                    <li>Targeting and Advertising: Cookies help us deliver advertisements that are more tailored to you and your interests, as well as limit the number of times you receive the same advertisement. We also use cookies to measure the effectiveness of our advertising campaigns.</li>
                                    <li>Social Networking: Cookies allow users to share our pages and content to third-party social networking sites.</li>
                                    <li>For an updated list of cookies on our Service, and your choices regarding them, please visit our Cookie List.</li>
                                </ul>
                                <p><strong>Web Beacons.</strong>{client_name.c_name} also uses electronic images known as web beacons (also known as pixels) on the Service. When you access a website, video, e-mail, or advertisement that contains a pixel, the pixel may permit us or a third party to drop or read cookies on your browser. Pixels are used in combination with cookies to track activity by a particular browser on a particular device. We may incorporate pixels from third parties that allow us track our conversions, bring you advertising both on and off the Service, and provide you with additional functionality, such as the ability to connect our Service with your social media account.</p>
                                <p><strong>Device Fingerprinting.</strong>Device fingerprinting is the process of analyzing and combining sets of information elements from your device’s browser, such as JavaScript objects and installed fonts, in order to create a “fingerprint” of your device and uniquely identify your device and apps.</p>
                                <p><strong>Location-Identifying Technologies.</strong>Location-aware technologies may be used to collect precise location data when you enable location-based services through your device. Location data may be used for purposes such as verifying your device’s location and delivering or restricting relevant content and advertising based on that location.</p>
                                <p>Some information about your use of the Service and certain Third Party Services (defined below) may be collected using Tracking Technologies across time and services and used by us and third parties for purposes such as to associate different devices you use, and deliver relevant ads and/or other content to you on the Service and certain Third Party Services.</p>
                                <p>For further information on Tracking Technologies and your rights and choices regarding them, see the sections entitled “Third Parties” and “Your Rights and Choices” below.</p>
                                <h2>Information From Other Sources</h2>
                                <p>As a general policy, {client_name.c_name} does not sell, trade or rent your information to third-parties, unless you have granted us permission to do so. However, {client_name.c_name} may obtain information about you from other third party sources. To the extent we combine the information you provide to {client_name.c_name} through the Service with information we have obtained from third party sources, we will treat the combined information in accordance with the practices described in this Privacy Policy, plus any additional restrictions imposed by the source of the data. These third party sources vary over time, but have included:</p>
                                <p>Data brokers from which we purchase demographic data to supplement the data we collect.</p>
                                <p>Social networks when you reference our Service or grant permission to {client_name.c_name} to access your data on one or more of these services.</p>
                                <p>Partners with which we offer co-branded services, sell or distribute our products, or engage in joint marketing activities.</p>
                                <p>Advertising partners.</p>
                                <p>Publicly-available sources such as open government databases or other data in the public domain.</p>
                                <p>For further information on Third Party Services, see the section entitled “Third Parties” below.</p>
                                <h2>Use of Information</h2>
                                <p>We use information about you for our legitimate interests, including to:</p>
                                <p>Manage our Service, including your registration, account, and transactions.</p>
                                <p>Perform services requested by you, such as to process and fulfill your order, to respond to your comments, questions, and requests, and provide customer service.</p>
                                <p>Send you technical notices, updates, security alerts, information regarding changes to our policies, and support and administrative messages.</p>
                                <p>Prevent or take action regarding illegal activities, including suspected fraud.</p>
                                <p>Monitor and analyze trends, usage, and activities.</p>
                                <p>Conduct internal research on our users' demographics, interests, behavior.</p>
                                <p>Improve our marketing and promotional efforts, Service content and product and service offerings.</p>
                                <p>Develop and send you direct marketing, including advertisements and communications about our and third party products, offers, promotions, rewards, events, and services.</p>
                                <p>We also use information about you with your consent, including to:</p>
                                <p>Verify your eligibility and deliver prizes in connection with Promotions you have entered.</p>
                                <p>Serve advertising tailored to your interests on our Service and Third Party Services.</p>
                                <p>Fulfill any other purpose disclosed to you and with your consent.</p>
                                <p>We may use information that does not identify you (including information that has been de-identified) without obligation to you except as prohibited by applicable law. For information on your rights and choices regarding how we use your information, please see the section entitled “Your Rights and Choices” below.</p>
                                <h2>Sharing of Information</h2>
                                <p>We share your information as follows:</p>
                                <p><strong>Service Providers.</strong>We share your information with third party agents, contractors, vendors, and other service providers in connection with their work on our behalf (collectively “Service Providers”). For example, if we need to ship something to you, we must share your name and address with a shipping company. Examples of other third parties that we may share your information with include: web hosting companies, fulfillment companies (e.g., companies that fulfill product orders), loose diamond suppliers, jewelers, assemblers, data analysis firms, affiliates, third party consulting or marketing firms, and e-mail service providers. Additionally, if you use a credit card or other financing alternative to place an order with {client_name.c_name}, we will use a third party payment processor to process your information in association with the transaction. We may also may share information with other companies and organizations for credit fraud protection and risk reduction. These third parties only receive your information if such information is needed to perform their function(s), and they are not authorized to use such information for any other purpose(s) other than the purpose(s) set forth by {client_name.c_name}. We only provide third-parties with the minimum amount of information necessary to complete the requested service, product or transaction. Notwithstanding the above, we may permit our Service Providers to use aggregate information which does not identify you or de-identified data for other purposes.</p>
                                <p><strong>Affiliates:</strong>We may share your information with our related entities including our parent and sister companies. For example, we may share your information with our affiliates for customer support, marketing, and technical operations.</p>
                                <p><strong>Business Partners:</strong>We may share your information with our business partners in connection with offering you co-branded services, selling or distributing our products, or engaging in joint marketing activities. For example, we may share information about you with a business partner for purposes of providing you with co-branded products or services that we may offer.</p>
                                <p><strong>Special Events:</strong>If you choose to participate in a special event (for example, a Promotion), {client_name.c_name} may share your information with those organizations participating in the applicable event. Typically, these third parties do not use your information for any other purpose other than to manage the event. In some cases these third-party partners may send you promotional materials regarding their products and services. In these cases, you will be given the opportunity to opt-out, and not have your information shared with that third-party partner. By entering a Promotion, you agree to the official rules that govern that Promotion, and may, except where prohibited by applicable law, allow the sponsor and/or other parties to use your name, voice and/or likeness in advertising or marketing materials.</p>
                                <p><strong>Feedback, Testimonials and User Provided Content.</strong>If you provide feedback or testimonials on the Service or on {client_name.c_name} products or services, or provide other User Provided Content (such as photos or videos), we may post and share this feedback, testimonial or other User Provided Content, including your information, on the Service, with third party partners, or in marketing and promotional materials. We may, by our sole discretion, edit feedback, testimonials or User Provided Content for length and content. California residents and data subjects in Europe have additional rights as set forth in “Your Rights and Choices” below.</p>
                                <p><strong>Third Parties.</strong> We may share your information with third parties for purposes of facilitating your requests (such as when you choose to share information with a social network about your activities on the Service) and in connection with tailoring advertisements, measuring and improving our Service and advertising effectiveness, and enabling other enhancements.</p>
                                <p><strong>Business Transfer.</strong>Your information may be disclosed as part of, or in connection with, any merger, sale of company assets, or acquisition, as well as in the event of an insolvency, bankruptcy or receivership, in which information would be transferred as one of the business assets of {client_name.c_name}.</p>
                                <p><strong>Security, Compliance with Law, and Fraud Protection.</strong>We may disclose your information as we deem necessary, in our sole discretion, to comply with any applicable law, regulation, legal process or governmental request. We also may share your information in order to investigate, prevent or take action regarding illegal activities, including suspected fraud, or as otherwise required by law. We may also share your information to protect the rights, property, life, health, security and safety of us, the Service or any third party.</p>
                                <p><strong>Consent.</strong>We may share your information for any other purpose disclosed to you and with your consent.</p>
                                <p>Without limiting the foregoing, in our sole discretion, we may share aggregated information which does not identify you or de-identified information about you with third parties or affiliates for any purpose except as prohibited by applicable law. For information on your rights and choices regarding how we share your information, please see the section entitled “Your Rights and Choices” below.</p>
                                <h2>Children</h2>
                                <p>{client_name.c_name} does not knowingly collect personal information from children under the age of thirteen (13). In the event that {client_name.c_name} ever does so, we will strictly comply with the Children's Online Privacy Protection Act (“COPPA”). If you are a parent or guardian and believe {client_name.c_name} has collected such information in a manner not permitted by COPPA, please contact us as set forth in the section entitled “Contact Us” below, and we will remove such data to the extent required by COPPA.</p>
                                <h2>Third Parties</h2>
                                <h2>Third Party Services</h2>
                                <p>Our Service may provide links to other third-party websites, locations, platforms, and services operated and owner by third parties (“Third Party Services”) which are outside our control and not covered by this privacy policy. We encourage you to review the privacy policies posted on these (and all) websites and services. These Third Party Services may use Tracking Technologies to independently collect information about you and may solicit information from you. The information collected and stored by third parties, whether through our Service, a Third Party Service, a Third Party Feature (defined below), or a third party device, remains subject to their own policies and practices, including what information they share with us, your rights and choices on their services and devices, and whether they store information in the U.S. or elsewhere. We encourage you to familiarize yourself with and consult their privacy policies and terms of use.</p>
                                <h2>Third Party Features</h2>
                                <p>We may allow you to connect our Service to a Third Party Service or offer our Service through a Third Party Service (“Third Party Features”). If you use a Third Party Feature, both we and the applicable third party may have access to and use information associated with your use of the Third Party Feature, and you should carefully review the third party’s privacy policy and terms of use. Some examples of Third Party Features include the following:</p>
                                <p><strong>Liking and Sharing.</strong>We may embed a pixel or SDK on our Service that allows you to “like” or “share” content on your {client_name.c_name} account through, Third Party Services, including social networks such as Facebook and Twitter. If you choose to engage with such a Third Party Service through our Service, we may collect any information you have authorized the Third Party Service to share with us (such as your user ID, billing information, public profile information, e-mail address, birthday, friends list, and other account and profile data). Likewise, if you choose to engage with such a Third Party Service through our Service or visit our Service while logged in to that Third Party Service on your device, the Third Party Service may receive information about your activities on our Service and be able to associate that information with information the Third Party Service already has about you.</p>
                                <h2>Analytics and Interest-Based Advertising</h2>
                                <p>Our Service contains Tracking Technologies owned and operated by Third Parties. For example, we use Tracking Technologies from third party analytics provides, such as Google Analytics, to help us analyze your use of the Service, compile statistic reports on the Service’s activity, and provide us with other services relating to Service activity and internet usage. We also work with ad serving services, advertisers, and other third parties to serve advertisements on the Service and/or on Third Party Services. These third parties may use Tracking Technologies on our Service and Third Party Services (including in e-mails and advertisements) to track your activities across time and services for purposes of associating the different devices you use, and delivering relevant ads and/or other content to you on the Service and Third Party Services or third party devices after you have left the Service (“Interest-based Advertising”).</p>
                                <p>We may serve ads on Third Party Services, such as Facebook and Google, which are targeted to reach people (or similar people) on those services that have visited our Service or that are also identified in one of more of our databases (“Matched Ads”). This is done by matching common factors between our data and the data of Third Party Services. If we use Facebook Custom Audiences to serve Matched Ads on Facebook services, you should be able to hover over the box in the right corner of such a Facebook ad and find out how to opt-out. We are not responsible for such Third Party Services’ failure to comply with your opt-out instructions.</p>
                                <h2>our Rights and Choices</h2>
                                <h2>Review and Update of Account Information</h2>
                                <p>You may access, update, or remove certain account information that you have voluntarily submitted to us through the Service. If you would like to update or revise information in your account, you may do so through your account or by contacting us as set forth in the section entitled “Contact Us” below. We may require additional information from you to allow us to confirm your identity. Please note that we will retain and use your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements. California residents and data subjects in Europe have additional rights as set forth in the sections entitled “Your California Privacy Rights” and “Your European Privacy Rights” below.</p>
                                <p>Please be aware that if you disable or remove Tracking Technologies some parts of the Service may not function correctly.</p>
                                <h2>Communications</h2>
                                <p>To opt-out of receiving e-mail promotions from {client_name.c_name}, please follow the unsubscribe instructions in our promotional e-mail correspondence or contact us as set forth in the section entitled “Contact Us” below. Please note that opting out of promotional communication received from {client_name.c_name} does not affect our non-promotional communications with you, including those related to your account, orders placed with {client_name.c_name}, or our ongoing business relations.</p>
                                <h2>Your California Privacy Rights</h2>
                                <p>If you are a customer in California, in addition to the rights set forth above, you have the right to request information from {client_name.c_name} regarding the manner in which {client_name.c_name} shares certain categories of personal information as defined by California’s “Shine the Light” with third parties and/or affiliates for their own direct marketing purposes. To receive this information, send us a request at the address set forth in the section entitled “Contact Us” below. Requests must include “California Privacy Rights Request” in the first line of the description and include your name, street address, city, state, and ZIP code. Please note that {client_name.c_name} may provide this information in a standardized format that is not specific to you and is not required to respond to requests made by means other than through the provided e-mail address or mail address.</p>
                                <p>Any California residents under the age of eighteen (18) who have registered to use the Service and posted content or information on the Service, can request that such information be removed from the Service by sending an e-mail to the e-mail address set forth in the section entitled “Contact Us” below. Requests must state that the user personally posted such content or information and detail where the content or information is posted. We will make reasonable good faith efforts to remove the post from prospective public view.</p>
                                <h2>Your European Privacy Rights</h2>
                                <p>If you are a data subject in Europe, you have the right to access, rectify, or erase any personal data we have collected about you through the Service. You also have the right to data portability and the right to restrict or object to our processing of personal data we have collected about you through the Service. In addition, you have the right to ask us not to process your personal data (or provide it to third parties to process) for marketing purposes or purposes materially different than for which it was originally collected or subsequently authorized by you. You may withdraw your consent at any time for any data processing we do based on consent you have provided to us.</p>
                                <p>To exercise any of these rights, contact us as set forth in the section entitled “Contact Us” below and specify which right you intend to exercise. We will respond to your request within 30 days. We may require additional information from you to allow us to confirm your identity. Please note that we store information as necessary to fulfil the purposes for which it was collected, and may continue to retain and use the information even after a data subject request for purposes of our legitimate interests, including as necessary to comply with our legal obligations, resolve disputes, prevent fraud, and enforce our agreements.</p>
                                <p>If you have any issues with our compliance, you have the right to lodge a complaint with a European supervisory authority.</p>
                                <h2>Data Security</h2>
                                <p>We implement and maintain reasonable administrative, physical, and technical security safeguards to help protect your information from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.</p>
                                <p>Despite the measures we take, transmission via the Internet is not completely secure and we cannot guarantee the security of your information.</p>
                                <h2>International Transfer</h2>
                                <p>{client_name.c_name} is based in the U.S. and the information we collect is governed by U.S. law. Your information may be stored and processed in the United States or any other country in which {client_name.c_name} or its partners, affiliates, service providers, subsidiaries or agents maintain facilities and by using this Website, you consent to any such transfer of information outside of your country. Data protection laws in the U.S. and other jurisdictions may be different from those of your country of residence. Your use of the Service or provision of any information therefore constitutes your consent to the transfer to and from, processing, usage, sharing, and storage of your information in the U.S. and other jurisdictions as set forth in this Privacy Policy. If your data is collected in Europe, we will transfer your personal data subject to appropriate or suitable safeguards.</p>
                                <h2>Contact Us</h2>
                                <p>If you have questions about this privacy policy, or the information practices, please contact us as follows:</p>
                                <p><strong>By Email:</strong> <NavLink onClick={(e) => { window.location.href = Email_details.link }} to="#">{Email_details.text}</NavLink></p>
                                <p><strong>By Address:</strong> <span>
                                    <li onClick={() => { window.open(Address_details.link, '_blank') }}>
                                        {Address_details.textLine1},{" "}   
                                        {Address_details.textLine2}
                                    </li>
                                </span></p> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
